"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientFactory = void 0;
const lodash_1 = require("lodash");
const settings_1 = require("./settings");
class ClientFactory {
    static init(settings) {
        Object.assign(settings_1.DefaultClientSettings, settings);
    }
    static get(Client, settings) {
        if (!(0, lodash_1.isEmpty)(settings)) {
            return new Client((0, lodash_1.merge)({}, settings_1.DefaultClientSettings, settings));
        }
        return new Client();
    }
}
exports.ClientFactory = ClientFactory;
//# sourceMappingURL=client.factory.js.map